import { LinkContent } from "./link-tree.types";

const albumReleaseDate = new Date('2025-10-17');

export const links: LinkContent[] = [
  {
    label: "Listen to 'Death Farm'",
    url: 'https://distrokid.com/hyperfollow/carlhauck/death-farm',
    condition: () => new Date() >= albumReleaseDate,
  }
];
